<div class="flex flex-col items-start">
  <label *ngIf="label" [for]="'otp-input-0'" class="block text-gray-1200 lg:text-[1.125rem] md:text-[1.125rem] sm:text-[1.125rem] xs:text-[1.125rem] text-[1rem] font-normal font-archivo leading-[29px]">{{label}}</label>
  <div class="flex flex-row w-full items-start justify-center  gap-[8px]">
    <input
      *ngFor="let box of digits; let i = index; trackBy: trackByIndex"
      #otpInput
      [id]="i === 0 ? 'otp-input-0' : null"
      type="text"
      inputmode="numeric"
      maxlength="1"
      [ngModel]="digits[i]"
      (ngModelChange)="onDigitChange($event, i)"
      (keydown)="onKeyDown($event, i)"
      (paste)="onPaste($event, i)"
      autocomplete="one-time-code"
      [attr.data-form-type]="'other'"
      [class]="'lg:w-[68.67px] md:w-[60px] sm:w-[55px] w-[53px] lg:h-[68.67px] md:h-[60px] sm:h-[55px] h-[46px] rounded-[8px] text-center text-xl font-normal outline-none transition lg:border-[2px] sm:border-[2px] md:border-[2px] xs:border-[2px]  border-[1px] font-archivo ' + (showError ? 'border-danger-500  focus:border-danger-500 focus:ring-danger-500/40' : 'border-secondary-500  focus:border-primary-500 focus:ring-0 focus:ring-primary-500/40')"
    />
  </div>

  <div  class=" flex flex-row items-center justify-center w-full text-danger-500 font-archivo lg:text-[18px] md:text-[18px] sm:text-[18px] xs:text-[18px] text-[16px] lg:min-h-[29px] lg:leading-[29px] md:min-h-[29px] md:leading-[29px] sm:min-h-[29px] sm:leading-[29px] xs:min-h-[29px] xs:leading-[29px] min-h-[25px] leading-[25px]">
    <span *ngIf="showError">{{ errorMessage }}</span>
  </div>
</div>
